import { render } from "./LogLista.vue?vue&type=template&id=54d177f6&ts=true"
import script from "./LogLista.vue?vue&type=script&lang=ts"
export * from "./LogLista.vue?vue&type=script&lang=ts"

import "./LogLista.vue?vue&type=style&index=0&id=54d177f6&lang=css"

import exportComponent from "/Users/camp/Desktop/code-time/acampa-gestao-pra/vuecode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__